import { TFunction } from 'react-i18next';
import { EventDetails } from 'services/ticketing/types';
import {
  ParentToSyosMessage,
  ProvideConfigurationMessage,
  ProvideSeatStatusesMessage,
  SetI18nMessage,
  SetSelectedSeatsMessage
} from './types';

// TODO: replace with real data
import { configurationData as mockConfigurationData } from './mocks/configuration';
import { i18nData as mockI18nData } from './mocks/i18n';
import { seatStatuses as statuses23 } from './mocks/seat-statuses-23';
import { seatStatuses as statuses24 } from './mocks/seat-statuses-24';
import { seatStatuses as statuses25 } from './mocks/seat-statuses-25';
import { seatStatuses as statuses26 } from './mocks/seat-statuses-26';

const exampleSeatStatuses = {
  23: statuses23,
  24: statuses24,
  25: statuses25,
  26: statuses26
} as const;

export const sendMessage = (message: ParentToSyosMessage) => {
  const iframe = document.getElementById('syos-iframe');
  if (!iframe || !(iframe instanceof HTMLIFrameElement)) return;

  const wrapped = {
    payload: message,
    source: 'jixaw-syos'
  };
  iframe.contentWindow?.postMessage(wrapped, '*');
};

export const sendI18nData = (t: TFunction) => {
  // TODO: add all strings to translation.json(s) and reference them here
  const setI18nMessage: SetI18nMessage = {
    ...mockI18nData,
    backToOverview: t('seatSelection.backToOverview'),
    type: 'SET_I18N'
  };

  sendMessage(setI18nMessage);
};

export const sendConfiguration = (requestId: string, eventDetails: EventDetails) => {
  // TODO: build configuration data from EventDetails
  const provideConfigurationMessage: ProvideConfigurationMessage = {
    ...mockConfigurationData,
    requestId,
    currentPerformanceId: eventDetails.id,
    performances: [
      {
        ...mockConfigurationData.performances[0],
        id: eventDetails.id
      },
      {
        ...mockConfigurationData.performances[1]
      }
    ],
    type: 'PROVIDE_CONFIGURATION'
  };

  sendMessage(provideConfigurationMessage);
};

export const sendSeatStatuses = (requestId: string, zoneIds: Array<string | number>) => {
  // TODO: build seat statuses from response of getEventSeats (new API)
  let seatStatuses: Record<string | number, boolean> = {};
  for (const zoneId of zoneIds) {
    if (zoneId in exampleSeatStatuses) {
      seatStatuses = {
        ...seatStatuses,
        ...exampleSeatStatuses[zoneId as keyof typeof exampleSeatStatuses]
      };
    }
  }

  const provideSeatStatusesMessage: ProvideSeatStatusesMessage = {
    requestId,
    type: 'PROVIDE_SEAT_STATUSES',
    seatStatuses
  };

  sendMessage(provideSeatStatusesMessage);
};

export const sendSelectedSeats = (selectedSeatIds: Set<string>) => {
  const setSelectedSeatsMessage: SetSelectedSeatsMessage = {
    seatIds: Array.from(selectedSeatIds),
    type: 'SET_SELECTED_SEATS'
  };

  sendMessage(setSelectedSeatsMessage);
};
